(ns storrito.instagram.story.editor.quick-stories
  (:require [storrito.instagram.story.editor.model :as editor.model]
            [storrito.instagram.story.editor.dimension :as dimension]
            [storrito.instagram.story.editor.render :as render]
            [storrito.image :as image]
            [storrito.video :as video]
            [cljs.core.async :refer [<!]]
            [cljs-http.client :as http]
            [storrito.video.config :as video-config]
            [sv.core.async :refer-macros [<?]]
            [app.upload-manager.core :as upload-manager])
  (:require-macros [cljs.core.async.macros :refer [go]]))

(defn save!
  "Uses the endpoint `/story-upload/save` to save a new story image or video
   entity. The gallery (`ui.gallery`) passes the folder that it shows as
   `:story-media/folder` in the `params`, without it the entity lands in
   the top-level gallery."
  [params]
  (go
    (let [response (<! (http/request
                         {:request-method :post
                          :url "/story-upload/save"
                          :transit-params params
                          :transit-opts {:encoding :json-verbose}}))]
      (if (= (:status response) 200)
        response
        ;; The message ends up in front of the user, so it must not be
        ;; the printed response map:
        (ex-info (str "The server responded with status " (:status response) ".")
                 {:response response})))))

(defn save-image-quick-story!
  "Given a blob-uuid pointing to an image of the right dimensions,
  this function creates a new story which only has that image as a
  background. The `params` are added to the `:story-upload/save!`
  command (see `save!` for `:story-media/folder`)."
  [blob-uuid file params]
  (assert blob-uuid)
  (assert file)
  (go
    (try
      ;; We need to do multiple things here:
      ;;
      ;; 1) Load `file` (the image the user uploaded) into an <img> for resizing
      ;; 2) Create a fabricjs-model with that image
      ;; 3) Render the user-image into an image that matches the fabricjs-model into a story-image
      ;; 4) Render that story-image in a lower resolution as a preview
      ;; 5) Upload the story-image and the preview-image
      ;; 6) Send the `:story-upload/save!` command to save the story image entity.
      (let [image (<? (image/load-image file))
            dimensions dimension/story-image
            fabricjs-model (editor.model/make-quick-story-model dimensions
                                                                {:background/size (image/dimensions image)
                                                                 :background/blob blob-uuid
                                                                 :background/constrain-fn image/fill})
            story-image-blob (-> (image/make-canvas dimensions)
                                 (image/background-color editor.model/default-background-color)
                                 (image/draw-blurry-background image)
                                 (image/draw-image-constrained image image/fill)
                                 (image/canvas-blob {:quality 85
                                                     :mime-type "image/jpeg"})
                                 (<?))
            story-image-blob-id (<? (upload-manager/upload-blob! {:blob story-image-blob
                                                                  :hidden true}))
            preview-blob (<? (render/constrain-image! editor.model/preview-side-length
                                                      story-image-blob))
            preview-blob-id (<? (upload-manager/upload-blob! {:blob preview-blob
                                                              :hidden true}))
            ]

        (assert preview-blob-id)
        (assert story-image-blob-id)
        ;; The gallery refreshes itself via the db-view notify loop
        ;; (`ui.notify`) once the story media is transacted:
        (<? (save! (merge
                     params
                     {:type :type.instagram.story/image
                      :story-media/preview-image-blob-id preview-blob-id
                      :story-media/blob-id story-image-blob-id
                      :story-media/fabricjs-model fabricjs-model
                      :story-media/file-name (.-name file)
                      :story-media/source-blob blob-uuid}))))

      ;; The caller (`storrito.upload.story-upload`) reports the error
      ;; to the user:
      (catch js/Error e
        e))))

(defn save-video-quick-story!
  "Like `save-image-quick-story!` for a video."
  [blob-uuid video-file params]
  (go
    (try
      (let [metadata (<? (video/metadata video-file))
            video-data {:instagram.video/start-time 0.00
                        :instagram.video/duration (min
                                                    (:storrito.video/duration metadata)
                                                    video-config/ig-story-max-duration)
                        :instagram.video/src-video-duration (:storrito.video/duration
                                                             metadata)}
            playable? (<! (video/compatible-video? video-file))]
        ;; See `save-image-quick-story!` for the gallery refresh:
        (<? (save! (merge
                     params
                     video-data
                     {:type :type.instagram/video
                      :story-media/file-name (.-name video-file)
                      :story-media/source-blob blob-uuid
                      :story-media/needs-transcode (not (boolean playable?))}))))
      ;; The caller (`storrito.upload.story-upload`) reports the error
      ;; to the user:
      (catch js/Error e
        e))))
